import React from 'react';
import PropTypes from 'prop-types';
import TrackVisibility from 'react-on-screen';
import SingleCountryMap from './SingleCountryMap';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBTimeSpent = ({ uuid = null, behaviorSettings = null, ...props }) => (
  <TrackVisibility
    once
    partialVisibility
    offset={0}
    className={`bb bb-time-spent ${styles['bb-time-spent']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    {({ isVisible }) => isVisible && <SingleCountryMap {...props} />}
  </TrackVisibility>
);

BBTimeSpent.propTypes = {
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBTimeSpent;
